import React from "react";
import "./PolicyStats.css";

const PolicyStats = ({ totalPolicies, activePolicies, draftsPending, archivedPolicies }) => {
    return (
        <div className="d-flex justify-content-between mb-5" style={{ gap: '20px' }}>
            <div className="policy-stat-card">
                <div className="stat-icon-wrapper blue-bg">
                    <i className="fa fa-folder-open text-primary" aria-hidden="true"></i>
                </div>
                <div>
                    <p className="stat-label">TOTAL POLICIES</p>
                    <h3 className="stat-value">{totalPolicies || 0}</h3>
                </div>
            </div>
            <div className="policy-stat-card">
                <div className="stat-icon-wrapper purple-bg">
                    <i className="fa fa-check-circle text-purple" aria-hidden="true"></i>
                </div>
                <div>
                    <p className="stat-label">ACTIVE POLICIES</p>
                    <h3 className="stat-value">{activePolicies || 0}</h3>
                </div>
            </div>
            <div className="policy-stat-card">
                <div className="stat-icon-wrapper orange-bg">
                    <i className="fa fa-pencil text-warning" aria-hidden="true"></i>
                </div>
                <div>
                    <p className="stat-label">DRAFTS PENDING</p>
                    <h3 className="stat-value">{draftsPending || 0}</h3>
                </div>
            </div>
            <div className="policy-stat-card">
                <div className="stat-icon-wrapper orange-bg">
                    <i className="fa fa-archive text-warning" aria-hidden="true"></i>
                </div>
                <div>
                    <p className="stat-label">ARCHIVED POLICIES</p>
                    <h3 className="stat-value">{archivedPolicies || 0}</h3>
                </div>
            </div>
        </div>
    );
};

export default PolicyStats;
